import _ from 'lodash';
import { adminClient as apolloClient } from '@/store/apollo';

import PurchasedItemsPaginatedGql from '@/extensions/shop/store/graphql/queries/PurchasedItemsPaginated.gql';
import UpdatePurchasedItemStocksGql from '@/extensions/shop/store/graphql/mutations/UpdatePurchasedItemStocks.gql';

export default {
    fetchPurchasedItemsPaginated: (data, purchase) =>
        new Promise((resolve, reject) => {
            let filters = [];
            _.each(data.filters, entry => filters.push(entry));

            if (data.mimicCustomer) {
                data.mimicCustomer = _.removeDeepByKey(data.mimicCustomer, '__typename')
            }

            apolloClient
                .query({
                    query: PurchasedItemsPaginatedGql,
                    variables: {
                        // Multistore: the store the admin UI currently has selected; the list
                        // shows its records by default and the store filter widens it again.
                        cms: _.get(data, 'cms') ? parseInt(_.get(data, 'cms')) : null,
                        scope: _.get(data, 'scope', 'ex'),
                        type: _.get(data, 'type', 'shop_purchase_article'),
                        currentPage: _.get(data, 'pageInfo.currentPage', 1),
                        perPage: _.get(data, 'pageInfo.perPage', 25),
                        order: _.get(data, 'variables.order', 'created_at'),
                        direction: _.get(data, 'variables.direction', 'desc'),
                        link: _.get(data, 'link.route', '/sales/order/'),
                        filters,

                        // custom
                        purchase,
                        mimicCustomer: _.get(data, 'mimicCustomer'),
                        includeWebShopPurchases: _.get(data, 'includeWebShopPurchases', true),
                        includeInternals: _.get(data, 'includeInternals', false),
                        includePointOfSalePurchases: _.get(data, 'includePointOfSalePurchases', false),

                        includeStocks: _.get(data, 'includeStocks', true),
                        includeImages: _.get(data, 'includeImages', false),
                    }
                })
                .then(({ data }) => resolve(data.CO_PurchasedItemsPaginated))
                .catch(err => reject(err));
        }),
    updatePurchasedItemStocks: purchasedItem => {
        if (purchasedItem === undefined) throw new Error('required argument is missing');
        purchasedItem = _.removeDeepByKey(purchasedItem, '__typename');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UpdatePurchasedItemStocksGql,
                    variables: { purchasedItem }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CO_UpdatePurchasedItemStock);
                })
                .catch(err => reject(err));
        });
    },
};
